// @ts-nocheck
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Header } from "../components/Header";
import Home from "../pages/Home";
import RoomService from "../pages/RoomService/index";
import ServiceMenu from "../pages/ServiceMenu/index"
import ServiceSummary from "../components/ServiceSummary";
import Menu from "../pages/Menu";
import Cart from "../pages/Cart";
import OrderStatus from "../pages/OrderStatus";
import ServiceStatus from "../pages/ServiceStatus";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import { cartProducts } from "../stores/cart/cartSlice";

/**
 * Every page opens at its top.
 *
 * Without this, walking from a menu scrolled halfway down to the order list lands the
 * guest in the middle of the new page - the router keeps the old offset. Keyed on the
 * path only, so the menu's own jump to a category (which changes just the query string)
 * still works, and it runs before that jump anyway.
 *
 * Both scrollers are reset: the window scrolls on a phone, while inside the desktop
 * phone frame it is #app-scroll that does.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        const frame = document.getElementById("app-scroll");
        if (frame) frame.scrollTop = 0;
    }, [pathname]);

    return null;
};

const Navigation = () => {
    const productsInCart = useSelector(cartProducts);

    return (
        <BrowserRouter >
            <ScrollToTop />
            <Header cartCount={productsInCart ? productsInCart.length : 0} />
            <div className="main-content"> {/* Adjusted top padding to match the smaller header */}
                <Routes>
                    <Route path="*" element={<Navigate to="/home" replace />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/home/:businessid" element={<Home />} />
                    <Route path="/menu" element={<Menu />} />
                    {/* <Route path="/menu/:businessid" element={<Menu />} /> */}
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/order-status" element={<OrderStatus />} />
                    <Route path="/service-status" element={<ServiceStatus />} />
                    <Route path="/room-service" element={<RoomService />} />
                    <Route path="/room-service/services" element={<ServiceMenu />} />
                    <Route path="/room-service/services/:id" element={<ServiceSummary />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                </Routes>
            </div>
            {/* Each page renders its own Footer, so there is none here. */}
        </BrowserRouter>
    );
};

export default Navigation;
